const theme = {
  fonts: {
    body: "system-ui, sans-serif",
    heading: '"Avenir Next", sans-serif',
    monospace: "Menlo, monospace"
  },
  breakpoints: [0],
  fontSizes: [12, 14, 16, 18, 24, 32, 48, 64],
  space: [0, 2, 4, 8, 16, 32, 64, 128],
  colors: {
    font: {
      primary: "#404040",
      secondary: "#737373",
      tertiary: "#737373"
    },
    background: {
      primary: "#FFFFFF",
      secondary: "#F2F2F2",
      tertiary: "#D9D9D9"
    }
  }
};
export const darkTheme = {
  fonts: {
    body: "system-ui, sans-serif",
    heading: '"Avenir Next", sans-serif',
    monospace: "Menlo, monospace"
  },
  breakpoints: [0],
  fontSizes: [12, 14, 16, 18, 24, 32, 48, 64],
  space: [0, 2, 4, 8, 16, 32, 64, 128],
  colors: {
    font: {
      primary: "#ffffff",
      secondary: "#dfdfdf",
      tertiary: "#737373"
    },
    background: {
      primary: "#2f2f2f",
      secondary: "#1f1f1f",
      tertiary: "#1f1f1f"
    }
  }
};
export default theme;